import React, {useEffect, useRef, useState} from 'react';
import {useForm} from 'react-hook-form';
import classNames from 'classnames';
import GateCheckboxComponent from "../../gateCheckbox/GateCheckboxComponent";
import Button from "../../Buttons/Button";
import Label from "../../Buttons/Label";
import {uploadFileToMongo} from "../../../services/PostService";
import {formGetter} from "../../../services/ApiService";
import {getGlobalGateForm} from "../../../services/DataGetter";
import {FormPartText} from "../../preScreening/FormPartText";
import {FormPartDate} from "../../preScreening/FormPartDate";
import {FormPartSelect} from "../../preScreening/FormPartSelect";
import {FormPartMultiSelect} from "../../preScreening/FormPartMultiSelect";
import {FormPartSection} from "../../preScreening/FormPartSection";
import IBAN from "iban";

export default function RegisterForm(props) {
	const {watch, register, handleSubmit, errors} = useForm();
	const hasError = (name) => {
		return errors.hasOwnProperty(name);
	};

	const [showErrors, setShowErrors] = useState(false)

	const sexInputUnselected = !watch('sex');

	useEffect(() => {
		if (props.positionId !== null) {
			if (props.formUrl === null) {
				setPSForm(null)
			} else {
				setForm(props.formUrl);
			}
		} else {
			loadGlobalForm();
		}
	}, []);
	const [uploadedCv, setUploadedCv] = useState(false)
	const [formResponse, setFormResponse] = useState(null)
	const fileInputRef = useRef();

	const [psForm, setPSForm] = useState(null)

	const isPersonalId = (x) => {
		x = x.trim()
		if (!isNumeric(x)) return false;
		if (!x) return false
		if (x.length === 0) return false
		if (x.length < 9) return false
		let year = parseInt(x.substr(0, 2), 10);
		let month = parseInt(x.substr(2, 2), 10);
		let day = parseInt(x.substr(4, 2), 10);
		let ext = parseInt(x.substr(6, 3), 10);
		if ((x.length === 9) && (year < 54))
			return true;
		let c = 0;
		if (x.length === 10)
			c = parseInt(x.substr(9, 1));
		let m = parseInt(x.substr(0, 9)) % 11;
		if (m === 10)
			m = 0;
		if (m !== c)
			return false;
		year += (year < 54) ? 2000 : 1900;
		if ((month > 70) && (year > 2003))
			month -= 70;
		else if (month > 50)
			month -= 50;
		else if ((month > 20) && (year > 2003))
			month -= 20;
		let d = new Date();
		if (month === 0) return false
		if (month > 12) return false
		if (day === 0) return false
		if (day > 31) return false

		return true;
	}

	const isNumeric = (n) => {
		n = n.replace(",", ".")
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

	const partHasError = (formPart, response) => {
		return formPart.type === 'select' ? (!response[formPart.id] || response[formPart.id].length === 0) : !response[formPart.id]
	};

	const textHasError = (formPart, response) => {
		if (!formPart.required && (!response[formPart.id] || response[formPart.id] === '')) return false;

		switch (formPart.validator.type) {
			case 'number':
				return !isNumeric(response[formPart.id]);
			case 'iban':
				return !IBAN.isValid(response[formPart.id]);
			case 'text':
				return false;
			case 'personalId':
				return !isPersonalId(response[formPart.id]);
		}
	};

	function onSubmit(data) {
		setShowErrors(true)
		if (errors && !(Object.keys(errors).length === 0 && errors.constructor === Object)) {
			return false;
		}

		if (psForm) {
			let response = []
			formResponse.formResponseParts.forEach((responsePart) => {
				if (responsePart.hasOwnProperty('formPartOptions')) {
					response[responsePart.formPartId] = responsePart.formPartOptions;
				} else if (responsePart.hasOwnProperty('value')) {
					response[responsePart.formPartId] = responsePart.value;
				} else {
					response[responsePart.formPartId] = null;
				}

			})

			let hasError = false;

			setShowErrors(false);
			Object.values(psForm.formParts).filter((formPart) => !formPart.hidden).sort((a, b) => ((a.order > b.order) ? 1 : -1)).forEach((formPart) => {
				hasError = hasError || (formPart.required && partHasError(formPart, response)) || (formPart.type === 'text' && !partHasError(formPart, response) && textHasError(formPart, response));
			});

			if (hasError) {
				setShowErrors(true);
				const element = document.getElementById(hasError);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' });
				}
				return;
			}
		}

		if (uploadedCv) {
			uploadFileToMongo(uploadedCv, props.customerName, props.language)
				.then(response => response.json())
				.then(json => {
					json.mongoId !== undefined && sessionStorage.setItem('cv-file-mongoid', json.mongoId);
					sessionStorage.setItem('cv-file-name', uploadedCv.name);
					sessionStorage.setItem('cv-file-size', uploadedCv.size);
					sessionStorage.setItem('cv-uploaded', json.mongoId);
					props.registerFunction(data, formResponse);
				})
		} else {
			props.registerFunction(data, formResponse);
		}
	}

	const loadGlobalForm = () => {
		getGlobalGateForm(props.customerName).then(response => response.json()).then(json => {
			if (json.form !== null) {
				setForm(json.form)
			} else {
				setPSForm(null)
			}
		});
	}
	const setForm = (formUrl) => {
		formGetter(formUrl)
			.then(response => response.json())
			.then(json => {
				json.formParts = Object.keys(json.formParts)
					.map((key) => json.formParts[key])
				setPSForm(json)
				let responseParts = []
				json.formParts.forEach((formPart) => {
					responseParts.push({
						"formPartId": formPart.id
					})
				})

				setFormResponse({
					"formId": json.id,
					"formResponseParts": responseParts
				})
			});
	}

	const saveFunction = (event, id, type) => {
		formResponse.formResponseParts.forEach((response) => {
			if (response.formPartId === id) {
				switch (type) {
					case 'select':
						response.formPartOptions = [event.target.value]
						break
					case 'multiSelect':
						if (event.target.checked) {
							if ('formPartOptions' in response) {
								response.formPartOptions.push(event.target.value)
							} else {
								response.formPartOptions = [event.target.value]
							}
						} else {
							let i = response.formPartOptions.indexOf(event.target.value)
							if (i > -1) {
								response.formPartOptions.splice(i, 1)
							}
						}
						break
					case 'text':
						response.value = event.target.value
						break
					case 'date':
						response.value = new Date(event).toDateString()
						break
					default:
						break
				}
			}
		})
		setFormResponse(formResponse)
	};

	return (
		<div className={'job-post-form'}>
			<div className={'basic-info-input'}>
				<form onSubmit={handleSubmit(onSubmit)} className={'col-12'}>
					<input type={"hidden"} value={props.positionId} name="positionId" ref={register({})}/>
					<input type={"hidden"} value={props.language} name="preferedLanguage" ref={register({})}/>
					<input type={"hidden"} value={props.customerName} name="customerName" ref={register({})}/>
					<div className={'row'}>
						{!props.prescreeningOnly &&
							<>
								<div className={'col-12 col-md-4'}>
									<div className="form-group floating-label">
										<select
											name="sex"
											id="sex"
											ref={register({required: true})}
											className={
												classNames('form-control', 'requiredField', {
													'inputHasError': hasError('sex', errors),
													'selected': !sexInputUnselected
												})
											}
											defaultValue={props.sex}>
											<option value="" disabled selected
													hidden>{window.Translator.getSlug('FormalAddress', props.language)}</option>
											<option value="0">{window.Translator.getSlug('Mr', props.language)}</option>
											<option
												value="1">{window.Translator.getSlug('Mrs', props.language)}</option>
										</select>
										<label
											htmlFor="firstName">{window.Translator.getSlug('FormalAddress', props.language)}</label>
										{hasError("sex", errors) && <span
											className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
									</div>
								</div>
								<div className={'col-12 col-md-4'}>
									<div className="form-group floating-label">
										<input onInput={e => props.checkCandidateExists(e.target.name, e.target.value)}
											   className={hasError("firstName", errors) ? 'form-control inputHasError' : 'form-control requiredField'}
											   type="text"
											   placeholder={window.Translator.getSlug('Firstname', props.language)}
											   name="firstName"
											   id="firstName"
											   ref={register({required: true, maxLength: 100})}
											   defaultValue={props.firstName}
										/>
										<label
											htmlFor="firstName">{window.Translator.getSlug('Firstname', props.language)}</label>
										{hasError("firstName", errors) && <span
											className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
									</div>
								</div>
								<div className={'col-12 col-md-4'}>
									<div className="form-group floating-label">
										<input onInput={e => props.checkCandidateExists(e.target.name, e.target.value)}
											   className={hasError("lastName", errors) ? 'form-control inputHasError' : 'form-control requiredField'}
											   type="text"
											   placeholder={window.Translator.getSlug('Lastname', props.language)}
											   name="lastName"
											   id="lastName"
											   ref={register({required: true, maxLength: 100})}
											   defaultValue={props.lastName}
										/>
										<label
											htmlFor="lastName">{window.Translator.getSlug('Lastname', props.language)}</label>
										{hasError("lastName", errors) && <span
											className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
									</div>
								</div>
								<div className={'col-12 col-md-4'}>
									<div className="form-group floating-label">
										<input onInput={e => props.checkCandidateExists(e.target.name, e.target.value)}
											   className={hasError("email", errors) ? 'form-control inputHasError' : 'form-control requiredField'}
											   type="text"
											   placeholder={window.Translator.getSlug('Email', props.language)}
											   ref={
												   register({
														   required: window.Translator.getSlug('ThisFieldIsRequired', props.language),
														   pattern: {
															   value: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
															   message: window.Translator.getSlug('TypeValidEmailAddress', props.language),
														   }
													   }
												   )}
											   name='email'
											   id='email'
											   defaultValue={props.email}/>
										<label
											htmlFor="email">{window.Translator.getSlug('Email', props.language)}</label>
										{hasError("email", errors) &&
											<span className="form-error-message">{errors.email.message}</span>}
									</div>
								</div>
								<div className={'col-12 col-md-4'}>
									<div className="form-group floating-label">
										<input
											className={hasError("phone", errors) ? 'form-control inputHasError' : 'form-control requiredField'}
											type="text"
											placeholder={window.Translator.getSlug('Phone', props.language)}
											name="phone"
											id="phone"
											ref={register({
												required: true,
												minLength: 6,
												maxLength: 20,
												pattern: /[+ ]*[( ]{0,1}[0-9]{1,4}[) ]{0,1}[-\\s\\./0-9]*/i
											})}
											defaultValue={props.phone}/>
										<label
											htmlFor="phone">{window.Translator.getSlug('Phone', props.language)}</label>
										{hasError("phone", errors) && <span
											className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
									</div>
								</div>
								<div className="col-12 col-md-4">
									{props.personalNumber && props.personalNumber !== 'hidden' && props.personalNumber !== 'undefined' && props.personalNumber !== 'null' &&
										<div className="form-group floating-label">
											<input
												id="personal-number-input"
												className={hasError("personalNumber", errors) ? 'form-control inputHasError' : 'form-control requiredField'}
												type="text"
												placeholder={window.Translator.getSlug('PersonalNumber', props.language)}
												name="personalNumber"
												ref={register({required: props.personalNumber === 'required'})}/>
											<label
												htmlFor="personal-number-input">{window.Translator.getSlug('PersonalNumber', props.language)}</label>
											{hasError("personalNumber", errors) && <span
												className="form-error-message">{window.Translator.getSlug('ThisFieldIsRequired', props.language)}</span>}
										</div>
									}
								</div>
								<div className={'col-12'}>
									<GateCheckboxComponent
										language={props.language}
										customerName={props.customerName}
										register={register} hasError={hasError}
										positionId={props.positionId}
										errors={errors}
										checkboxes={props.checkboxes}
									/>
								</div>
								{(props['skipCv'] === '1') &&
									(
										<div className={"col-4 height-30 border-radius-1 margin-bottom-20"}>
											<input
												disabled={uploadedCv}
												ref={fileInputRef}
												type="file"
												id="cv_file"
												name="cv_file"
												className={'inputfile col-12'}
												onChange={(e) => {
													setUploadedCv(e.target.files[0])
												}}
											/>
											<Label uploadedCv={uploadedCv} customerName={props.customerName}
												   className={'col-12 height-60'}
												   htmlFor={"cv_file"} positionId={props.positionId}>
												<i className={'fa fa-fw fa-file-upload margin-right-10  padding-top-20 padding-bottom-20 padding-left-0-75rem'}> </i>
												{window.Translator.getSlug('AttachYoursCv', props.language)} &nbsp;
											</Label>
										</div>)}
							</>}
						<div className={'col-12'}>
							{psForm && (<div className={'content-section'}>
								<div className={'job-post-form'}>
									<div className={'basic-info-input'}>
										<div className={'row'}>
											<div className={'col-12 '}>
												<form>
													{psForm.hasOwnProperty('formParts') && psForm.formParts.sort((a, b) => ((a.order > b.order) ? 1 : -1)).map((formPart) => {
														if (formPart.hidden)
															return null
														switch (formPart.type) {
															case 'text':
																return (<FormPartText
																	formPart={formPart}
																	saveFunction={saveFunction}
																	lang={props.language}
																	register={register}
																	hasError={hasError}
																	errors={errors}
																	isNumeric={isNumeric}
																	isIdentificationNumber={isPersonalId}

																/>);
															case 'date':
																return (<FormPartDate
																	formPart={formPart}
																	saveFunction={saveFunction}
																	lang={props.language}
																	register={register}
																	hasError={hasError}
																	errors={errors}
																	showErrors={showErrors}
																/>);
															case 'select':
																return formPart.allowMultiple === false ? (
																	<FormPartSelect
																		formPart={formPart}
																		saveFunction={saveFunction}
																		lang={props.language}
																		register={register}
																		hasError={hasError}
																		errors={props.errors}
																	/>) : (<FormPartMultiSelect
																	formPart={formPart}
																	saveFunction={saveFunction}
																	lang={props.language}
																	register={register}
																	hasError={hasError}
																	errors={errors}
																	showErrors={showErrors}
																/>);
															case 'section': {
																return <FormPartSection
																	formPart={formPart}/>
															}
															default:
																return null;
														}
													})}
												</form>
											</div>
										</div>
									</div>
								</div>
							</div>)}
						</div>
						<div className={'col-10 col-lg-4'}>
							<Button
								disabled={props.requireCv && (!uploadedCv && !sessionStorage.getItem('cv-uploaded'))}
								className={'btn btn-primary register-button'}
								type={'submit'}
								buttonType={"register-button"}
								positionId={props.positionId}
								customerName={props.customerName}
								onClick={() => setShowErrors(true)}
							>
								{window.Translator.getSlug('ApplyNow', props.language)}
							</Button>
						</div>
					</div>
				</form>
			</div>
		</div>
	);
}



